import { css } from "@emotion/react";

import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { Button } from "antd";

import { Blank } from "@/components/Layout";

function NotFound() {
  const history = useHistory();

  const handleClick = useCallback(() => {
    history.go(-1);
  }, []);

  return (
    <Blank>
      <div css={notFound}>
        <div className="ant-result ant-result-info">
          <div className="ant-result-title">404</div>
          <div className="ant-result-subtitle">
            Sorry, the page you visited does not exist.
          </div>
          <div className="ant-result-extra">
            <Button type="primary" shape="round" onClick={handleClick}>
              Back
            </Button>
          </div>
        </div>
      </div>
    </Blank>
  );
}

const notFound = (theme) => css`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default NotFound;
